import _ from 'lodash';
import { aan_split } from '../utils/patterns';

//combines error messages into one
export function errorScript(response) {
  let type = typeof response.data.detail;
  let text = '';
  if (type === 'string') {
    text = response.data.detail;
  } else {
    response.data.detail.forEach((x) => {
      text += x.msg + '. ';
    });
  }
  return text;
}

//-------------------------------------- Function 1 ------------------------------------------------//

//Custom functions created for alert screen cards
//Sub-Function (used below): get unique dimensioal filter names
export function dimensionFields(anomaly, key) {
  let lookup = {};
  let aan = [];
  for (let item, i = 0; (item = anomaly[i++]); ) {
    let name = item[key];
    if (!(name in lookup)) {
      lookup[name] = 1;
      let values = name.split(aan_split);
      values.forEach((x) => aan.push(x));
    }
  }
  if (aan.length > 0) return _.uniq(aan).sort();
  return false;
}

//Function 1: Filters the anomaly list based on user selection
export function filterAnomaly(anomaly, filter) {
  return anomaly.filter(function (el) {
    let val = false;
    Object.keys(filter).every((key, i) => {
      const aanValue = dimensionFields(anomaly, 'aan_level');
      const filterLength = filter[key].length === 0;
      const filterMatch = filter[key].indexOf(el[key]) >= 0;
      if (aanValue.indexOf(key) < 0) {
        val = filterLength || filterMatch ? true : false;
      } else {
        if (!filterLength) {
          filter[key].every((value) => {
            val = el['aan_value_new'].includes(value);
            if (val) return false;
            else return true;
          });
        } else val = true;
      }
      if (!val) return false;
      else return true;
    });
    return val;
  });
}

//-------------------------------------- Function 2 ------------------------------------------------//
//Custom functions created for alert screen cards
//Sub-Function(used below): only for aan_level (standard filters)
export function uniqueAan(anomaly, key) {
  let lookup = {};
  let result = [];
  let aan = [];
  for (let item, i = 0; (item = anomaly[i++]); ) {
    let name = item[key];
    if (!(name in lookup)) {
      lookup[name] = 1;
      let values = name.split(aan_split);
      values.forEach((x) => aan.push(x));
    }
  }
  if (aan.length > 0) {
    _.uniq(aan)
      .sort()
      .forEach((x) => result.push({ key: x, value: x, text: x, label: x }));
  }
  return result;
}

//Function 2: only for aan_level (dimensional filters)
export function uniqueAanValues(anomaly) {
  let lookup = {};
  let result = {};
  let keys = uniqueAan(anomaly, 'aan_level');
  keys.forEach((x) => (result[x.value] = []));
  for (let item, i = 0; (item = anomaly[i++]); ) {
    let level = item['aan_level'].split(aan_split);
    //let separators = ['-\\*\\*-',''-\\*-']
    //new RegExp(separators.join("|"), "g")
    let value = item['aan_value_new'];
    if (!(value in lookup)) {
      lookup[value] = 1;
      value.split(aan_split).forEach((x, i) => result[level[i]].push(x));
    }
  }
  keys.forEach((x) => (result[x.value] = _.uniq(result[x.value]).sort()));
  Object.keys(result).forEach(function (key) {
    result[key].forEach((x, i) => (result[key][i] = { key: x, value: x, text: x, label: x }));
  });
  return result;
}

//-------------------------------------- Function 3 (JSON) ------------------------------------------------//

export function uniqueList(data, key, onlyvalues = false, sort = true) {
  let lookup = {};
  let result = [];
  for (let item, i = 0; (item = data[i++]); ) {
    const name = item[key];
    if (!(name in lookup)) {
      lookup[name] = 1;
      const value = onlyvalues ? name : { key: name, value: name, text: name };
      result.push(value);
    }
  }
  if (sort) result.sort();
  return result;
}

//finds the unique value for a key in json
export function uniqueCountList(data, key) {
  let lookup = {};
  for (let item, i = 0; (item = data[i++]); ) {
    const name = item[key];
    if (!(name in lookup)) {
      lookup[name] = 1;
    } else {
      lookup[name] += 1;
    }
  }
  return lookup;
}

//finds count of one value in a key in json
export function valueCountList(data, key, value) {
  let count = 0;
  for (let item, i = 0; (item = data[i++]); ) {
    const name = item[key];
    if (name === value) {
      count += 1;
    }
  }
  return count;
}

//HomePageFilters, HomePage
export function uniqueSortedList(data, key, onlyvalues = false, addall = false) {
  let lookup = {};
  let result = [];
  let resultsortted = [];
  for (let item, i = 0; (item = data[i++]); ) {
    const name = item[key] ? item[key] : '';
    if (!(name in lookup) && name) {
      lookup[name] = 1;
      result.push(name);
    }
  }
  result.sort();
  //Hardcoding for All values in list to come first
  if (key === 'period') result.reverse();
  if (result.indexOf('All') >= 0 || result.indexOf('ALL') >= 0 || result.indexOf('all') >= 0) {
    result.splice(result.indexOf('All'), 1);
    result.splice(0, 0, 'All');
  }
  if (addall) result.splice(0, 0, 'ALL');
  //Final format creation
  result.forEach((val) => {
    val = val.toUpperCase();
    resultsortted.push(onlyvalues ? val.toUpperCase() : { key: val, value: val, text: val });
  });
  return resultsortted;
}

//Filter JSON for selection, pass selection as { key: filtervalue }
export function filterJson(data, selection) {
  return data.filter(function (el) {
    let val = false;
    Object.keys(selection).every((key, i) => {
      const filterLength = selection[key].length === 0;
      let a = selection[key] ? selection[key] : '';
      let b = el[key] ? el[key].toLowerCase() : '';
      if (typeof a === 'string') a = a.toLowerCase();
      else if (typeof a === 'object') a = a.map((val) => val.toLowerCase());
      const filterMatch = a.indexOf(b) >= 0;
      val = filterLength || filterMatch ? true : false;
      return val;
    });
    return val;
  });
}

//Find max numeric value in json for provided key
// data = [{state:'A',sales:452},{state:'A',sales:102}]
// keys = ['sales'] - provide list to get max
export function maxJson(data, key) {
  let max = 0;
  data.forEach((x, i) => {
    key.forEach((y, j) => {
      if (parseFloat(x[y]) > max) {
        max = parseFloat(x[y]);
      }
    });
  });
  return max;
}

//Find max string length of value in json for provided key
// data = [{state:'A',sales:452},{state:'A',sales:102}]
// keys = 'state' - provide the dimension name to get length
export function maxStringJson(data, key) {
  let max = 0;
  data.forEach((x) => {
    if (x[key] && x[key].toString().trim().length > max) {
      max = x[key].toString().trim().length;
    }
  });
  return max;
}

//-------------------------------------- Function 4 (Currency) -----------------------------------------//

//Currency formatters: comma separated value
//Example: 1,22,321.00
export function toIndianCommaSeparated(value, decimal = 2) {
  return value.toLocaleString('en-IN', {
    style: 'decimal',
    maximumFractionDigits: decimal
  });
}

//Example: $122,321.00
export function toUSCommaSeparated(value, fractions = 0) {
  return value.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: fractions
  });
}

//Example: ₹1,22,321
export function toIndianCurrency(value) {
  const curr = value.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR'
  });
  return curr;
}

//Example: 1.20 Cr, 2L, 22.3K
export function currency(value, currency = '') {
  const absvalue = Math.abs(value);
  // rupee
  const unit =
    absvalue / 10000000 >= 1
      ? 'Cr'
      : absvalue / 100000 >= 1
      ? 'L'
      : absvalue / 1000 >= 1
      ? 'K'
      : '';
  const denominator =
    absvalue / 10000000 >= 1
      ? 10000000
      : absvalue / 100000 >= 1
      ? 100000
      : absvalue / 1000 >= 1
      ? 1000
      : 1;
  // dollar
  const dollarunit =
    absvalue / 1000000000000000 >= 1
      ? 'Q'
      : absvalue / 1000000000000 >= 1
      ? 'T'
      : absvalue / 1000000000 >= 1
      ? 'B'
      : absvalue / 1000000 >= 1
      ? 'M'
      : absvalue / 1000 >= 1
      ? 'K'
      : '';
  const dollardenominator =
    absvalue / 1000000000000000 >= 1
      ? 1000000000000000
      : absvalue / 1000000000000 >= 1
      ? 1000000000000
      : absvalue / 1000000000 >= 1
      ? 1000000000
      : absvalue / 1000000 >= 1
      ? 1000000
      : absvalue / 1000 >= 1
      ? 1000
      : 1;
  value = Math.round((value / (currency ? dollardenominator : denominator)) * 100, 0) / 100;
  value = value.toString() + (currency === '$' ? dollarunit : unit);
  return value;
}

//Example: 123.5 K, 4,721 K
export function thousandsValue(value) {
  const absvalue = Math.abs(value);
  const unit = absvalue / 1000 >= 1 ? 'K' : '';
  const denominator = absvalue / 1000 >= 1 ? 1000 : 1;
  value = Math.round((value / denominator) * 10, 0) / 10;
  value = toIndianCommaSeparated(value).toString() + ' ' + unit;
  return value;
}

//function to make the values in objects of array to two decimals
export function valuesrounder(array) {
  let rounded = array;
  rounded.forEach((el) => {
    Object.keys(el).forEach(function (key) {
      if (!isNaN(parseFloat(el[key]))) {
        el[key] = parseFloat(el[key]);
        el[key] = el[key].toFixed(2);
      }
    });
  });
  return rounded;
}

//add days to provided date
export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

//capitalize all words in a sentence
export function Capitalize(str) {
  const arr = str.split(' ');
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(' ');
  return str2;
}

export function generateUniqueId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const HTMLformatter = (inference) => {
  const statement = inference
    .replaceAll('<g>', '<b><span class="green-text">')
    .replaceAll('</g>', '</span></b>')
    .replaceAll('<r>', '<b><span class="red-text">')
    .replaceAll('</r>', '</span></b>');
  return statement;
};

export const HTMLremover = (inference) => {
  const statement = inference
    .replaceAll('<b>', '')
    .replaceAll('</b>', '')
    .replaceAll('<g>', '')
    .replaceAll('</g>', '')
    .replaceAll('<r>', '')
    .replaceAll('</r>', '');
  return statement;
};

export const optionsCreator = (options) => {
  return options.map((x) => {
    return {
      value: x,
      label: x.replaceAll('-**-', ' | ').replaceAll('-*-', ' | ')
    };
  });
};

export const kpiFormatApplier = (value, format) => {
  if (format === '#') {
    return currency(value, '$');
  } else if (format === '%') {
    // use this when percentage column needs to be multiplied by 100
    return (Math.round(value * 100 * 100) / 100).toString() + '%';
  } else if (format === '%#') {
    // use this when percentage column is multiplied by 100
    return (Math.round(value * 100) / 100).toString() + '%';
  } else if (format === '$') {
    // use this when dollar values should be in K, M & B
    return '$' + currency(value, '$');
  } else if (format === '$#') {
    // use this when dollar values should be in absolute
    return '$' + toUSCommaSeparated(value);
  } else if (format === '₹') {
    // use this when dollar values should be in K, L & Cr
    return '₹' + currency(value, '₹');
  } else if (format === '₹#') {
    // use this when dollar values should be in absolute
    return toIndianCommaSeparated(value);
  } else {
    return Math.round(value * 100) / 100;
  }
};

//-------------------------------------- Function 5 (Date) -----------------------------------------//

export const convertDateFormat = (dateString, showday = false) => {
  // Parse input date string (yyyy-mm-dd) into a Date object
  const date = new Date(dateString);
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  // Format the output date string (mmm yyyy)
  const formattedDate = showday ? `${month} ${day}, ${year}` : `${month} ${year}`;
  return formattedDate;
};
